<template>
    <div>
        <div class="modal fade" :id="modal_name" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Medicamentos</h5>
                        <button type="button" class="close" @click="fechar_modal()" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div v-if="atendimento && atendimento.paciente" class="alert alert-info">
                            {{ atendimento.paciente.search }} 
                        </div>

                        <az-input
                            sizing="sm"
                            v-model="search"
                            :placeholder="'Pesquisar...'"
                            icon="fa-solid fa-magnifying-glass"
                            class="mb-2" />

                        <table class="table table-sm border-0 table-responsive mb-1" v-if="classes && classes.length">
                            <tr>
                                <td class="text-nowrap">
                                    <a href="#" @click.prevent="filtrar('classe', classe)" v-for="(classe, icx) in classes" :key="icx">
                                        <span class="badge mr-1" :class="classe == filtros.classe ? 'badge-success' : 'badge-secondary'">
                                            {{ classe }}
                                        </span>
                                    </a>
                                </td>
                            </tr>
                        </table>

                        <div class="mb-1">
                            <span v-for="(filtro, key) in filtros" :key="key">
                                <span v-if="filtro">
                                    <span class="badge badge-primary mr-1">
                                        {{ key == 'titulo' ? 'Protocolo' : key }}: {{ filtro }}
                                        <a href="#" @click.prevent="filtrar(key, filtro)" class="ml-1">
                                            <i class="fa-solid fa-xmark text-light"></i>
                                        </a>
                                    </span>
                                </span>
                            </span>
                        </div>

                        <ul class="nav nav-tabs" id="myTab" role="tablist">
                            <li class="nav-item" role="presentation">
                                <a class="nav-link active" id="home-tab" data-toggle="tab" href="#home" role="tab" aria-controls="home" aria-selected="true">
                                    Medicamento
                                    <span class="badge badge-secondary ml-1" v-if="exibicao.length">{{ exibicao.length }}</span>
                                </a>
                            </li>
                            <li class="nav-item" role="presentation">
                                <a class="nav-link" id="profile-tab" data-toggle="tab" href="#profile" role="tab" aria-controls="profile" aria-selected="false">
                                    Infusão
                                    <span class="badge badge-secondary ml-1" v-if="Object.keys(infusoes).length">{{ Object.keys(infusoes).length }}</span>
                                </a>
                            </li>
                            <li class="nav-item" role="presentation">
                                <a class="nav-link" id="protocolos-tab" data-toggle="tab" href="#protocolos" role="tab" aria-controls="protocolos" aria-selected="false">
                                    Protocolos
                                    <span class="badge badge-secondary ml-1" v-if="Object.keys(lista_protocolos).length">{{ Object.keys(lista_protocolos).length }}</span>
                                </a>
                            </li>
                        </ul>
                        <div class="tab-content" id="myTabContent">
                            <!-- Medidcamentos -->
                            <div class="tab-pane fade show active" id="home" role="tabpanel" aria-labelledby="home-tab">
                                
                                <table class="table table-hover table-sm small mt-3">
                                    <thead>
                                        <tr>
                                            <th></th>
                                            <th>Atend</th>
                                            <th>Data</th>
                                            <th>Procedimento</th>
                                            <th>Médico</th>
                                            <th>Medicamento</th>
                                            <th>Dose</th>
                                            <th>Peso</th>
                                            <th>Calculada</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(item, index) in exibicao" :key="index">
                                            <td>
                                                <i class="fa-solid fa-pills fa-fw" v-if="item.fl_prescricao"></i>
                                                <i class="fa-solid fa-prescription fa-fw" v-else></i>
                                            </td>
                                            <td>#{{ item.id_atendimento }}</td>
                                            <td>{{ $util.getFormatDate(item.dt_inicio) }}</td>
                                            <td>
                                                <a href="#" @click.prevent="filtrar('procedimento', item.procedimento)" class="card-link">
                                                    {{ item.procedimento }}
                                                </a>
        
                                                <span v-if="item.infusao_d || item.infusao_c" class="text-muted">
                                                    <span class="ml-1" v-if="item.infusao_c">C{{ item.infusao_c }}</span>
                                                    <span class="ml-1" v-if="item.infusao_d">/ D{{ item.infusao_d }}</span>
                                                </span>
                                            </td>
                                            <td>
                                                <a href="#" @click.prevent="filtrar('medico', item.medico)" class="card-link">
                                                    {{ item.medico }}
                                                </a>
                                            </td>
                                            <td>
                                                <a href="#" @click.prevent="filtrar('medicamento', item.item.search)" class="card-link">
                                                    {{ item.item.search }}
                                                </a>
                                            </td>
                                            <td>{{ item.quantidade }}</td>
                                            <td>{{ item.in_peso }}</td>
                                            <td>
                                                <span v-if="item.dc_dose_calc">
                                                    {{ item.dc_dose_calc }}
                                                    <span v-if="item.apresentacao.st_unid_calc" class="text-muted">
                                                        {{ item.apresentacao.st_unid_calc }}
                                                    </span>
                                                </span>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>

                            </div>

                            <!-- Infusãao -->
                            <div class="tab-pane fade" id="profile" role="tabpanel" aria-labelledby="profile-tab">

                                <table class="table table-hover table-sm small mt-3">
                                    <thead>
                                        <tr>
                                            <th></th>
                                            <th>Atend</th>
                                            <th>Data</th>
                                            <th>Procedimento</th>
                                            <th>Ciclo</th>
                                            <th>D</th>
                                            <th>Médico</th>
                                            <th>Protocolo</th>
                                            <th>Peso</th>
                                        </tr>
                                    </thead>
                                    <tbody v-for="(items, id_receita, index) in infusoes" :key="index">
                                        <tr>
                                            <td>
                                                <a href="#" @click.prevent="items[0].expandido = !items[0].expandido" class="card-link">
                                                    <i class="fa-regular fa-square-plus fa-fw" v-if="!items[0].expandido"></i>
                                                    <i class="fa-regular fa-square-minus fa-fw" v-else></i>
                                                </a>
                                            </td>
                                            <td>#{{ items[0].id_atendimento }}</td>
                                            <td>{{ $util.getFormatDate(items[0].dt_inicio) }}</td>
                                            <td>
                                                <a href="#" @click.prevent="filtrar('procedimento', items[0].procedimento)" class="card-link">
                                                    {{ items[0].procedimento }}
                                                </a>
                                            </td>
                                            <td>
                                                C{{ items[0].infusao_c }}
                                            </td>
                                            <td>
                                                D{{ items[0].infusao_d }} 
                                            </td>
                                            <td>
                                                <a href="#" @click.prevent="filtrar('medico', items[0].medico)" class="card-link">
                                                    {{ items[0].medico }}
                                                </a>
                                            </td>
                                            <td>
                                                <a href="#" @click.prevent="filtrar('medicamento', items[0].titulo)" class="card-link">
                                                    {{ items[0].titulo }}
                                                </a>
                                            </td>
                                            <td>{{ items[0].in_peso }}</td>
                                        </tr>
                                        <template v-if="items[0].expandido">
                                            <tr>
                                                <td></td>
                                                <td colspan="8">
                                                    <ul class="list-group mb-0">
                                                        <li class="list-group-item d-flex justify-content-between p-1" v-for="(medic, imx) in items" :key="index + '.' + imx">
                                                            <div>
                                                                {{ medic.item.search }}
                                                            </div>
                                                            <div>
                                                                {{ medic.quantidade }}
                                                                <span v-if="medic.dc_dose_calc">
                                                                    <i class="fa-solid fa-caret-right fa-fw mx-2"></i>
                                                                    {{ medic.dc_dose_calc }}
                                                                    <span v-if="medic.apresentacao.st_unid_calc">
                                                                        {{ medic.apresentacao.st_unid_calc }}
                                                                    </span>
                                                                </span>
                                                            </div>
                                                        </li>
                                                    </ul>
                                                </td>
                                            </tr>
                                        </template>
                                    </tbody>
                                </table>
                                
                            </div>

                            <!-- Protocolos -->
                            <div class="tab-pane fade" id="protocolos" role="tabpanel" aria-labelledby="protocolos-tab">

                                <table class="table table-hover table-sm small mt-3">
                                    <thead>
                                        <tr>
                                            <th>Protocolo</th>
                                            <th>Início</th>
                                            <th>Último</th>
                                            <th>Ciclos</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(items, titulo, index) in lista_protocolos" :key="index">
                                            <td>
                                                <a href="#" @click.prevent="filtrar('titulo', titulo)" class="card-link">{{ titulo }}</a>
                                            </td>
                                            <td>{{ $util.getFormatDate(ident_data(items, 'p')) }}</td>
                                            <td>{{ $util.getFormatDate(ident_data(items, 'u')) }}</td>
                                            <td>{{ calc_ciclos(items) }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                                
                            </div>
                        </div>

                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" @click="fechar_modal()">Fechar</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import AzInput from '../../shared/forms/AzInput.vue';

export default {
    data() {
        return { 
            dados: null, 
            search: "",
            filtros: { 
                procedimento: null,
                medico: null,
                medicamento: null,
                classe: null,
                titulo: null, 
            }, 
            classes: [], 
            modal_name: "modalInfoMedicamentos", 
            atendimento: null, 
        }
    },

    components: { 
        AzInput
    },

    computed: { 
        exibicao() {
            if ( !this.dados ) {
                return [];
            }

            let reg = this.$util.getregex(this.search);

            return this.dados.filter(item => ( !this.search || reg.test(JSON.stringify(item)) )
                && ( !this.filtros.procedimento || item.procedimento == this.filtros.procedimento )
                && ( !this.filtros.medico || item.medico == this.filtros.medico )
                && ( !this.filtros.medicamento || ( item.item && item.item.search == this.filtros.medicamento ) )
                && ( !this.filtros.classe || ( item.item && item.item.js_classes && item.item.js_classes.includes(this.filtros.classe)) )
            );
        },

        infusoes: function () { 
            return _.groupBy(
                this.exibicao.filter(item => item.fl_prescricao && item.infusao_d),
                item => 'R' + item.dt_inicio + '-' + item.id_receita
            );
        },

        lista_protocolos: function () { 
            return _.groupBy(
                this.exibicao.filter(item => item.fl_prescricao && item.infusao_d),
                item => item.titulo
            );
        }
    },
    
    methods: { 
        ident_data (items, tipo) { 
            if ( !items || !items.length ) {
                return null;
            }

            if ( tipo == 'p' ) {
                return _.get( 
                    _.minBy(items, 'dt_inicio'),
                    'dt_inicio'
                );
            } else if ( tipo == 'u' ) {
                return _.get(
                    _.maxBy(items, 'dt_inicio'),
                    'dt_inicio'
                );
            }

            return null;
        },

        calc_ciclos (items) { 
            if ( !items || !items.length ) {
                return 0;
            }

            let ciclos = items.map(item => item.id_infusao);
            return _.uniq(ciclos).length;
        },

        fechar_modal() { 
            $('#' + this.modal_name).modal('hide');
        },

        filtrar (origem, texto) { 
            if ( this.filtros[origem] == texto ) {
                this.filtros[origem] = "";
            } else {
                this.filtros[origem] = texto;
            }
        },

        filtrar_texto (texto) { 
            if ( this.search == '"' + texto + '"' ) {
                this.search = "";
            } else {
                this.search = '"' + texto + '"';
            }
        },

        abrir (dados, atendimento = null) { 
            this.atendimento = atendimento;

            let lista = _.cloneDeep(dados);

            this.dados = lista.flatMap(item => {
                
                if ( !item.atendimento ) {
                    return [];
                }

                if ( !item.atendimento.atendimento_procedimentos ) {
                    return [];
                }


                return item.atendimento.atendimento_procedimentos.flatMap(atp => {

                    if ( !atp.anamnese ) {
                        return [];
                    }

                    return atp.anamnese.receita.flatMap(receita => { 
                        return receita.items.concat(
                            receita.items.flatMap(i => {
                                if ( !i.diluidos ) {
                                    return [];
                                }

                                return i.diluidos;
                            })
                        )
                        .map(rm => { 
                            rm.id_atendimento = item.id_atendimento;
                            rm.id_atendimento_pesq = '#' + item.id_atendimento;
                            rm.dt_inicio = item.atendimento.dt_inicio;
                            rm.procedimento = atp.procedimento ? atp.procedimento.st_procedimento : '?';
                            rm.medico = item.medico ? item.medico.search : '?';
                            rm.in_peso = receita.in_peso;
                            rm.fl_prescricao = receita.fl_prescricao;
                            rm.diluidos = null;
                            rm.infusao_d = item.in_qt_dia;
                            rm.infusao_c = item.in_qt_ciclo;
                            rm.titulo = _.get(item, 'infusao.st_titulo');
                            rm.id_receita = receita.id_receita;
                            rm.expandido = false;
                            rm.id_infusao = _.get(item, 'infusao.id_infusao');

                            return rm;
                        });
                    });

                });

            });

            this.classes =  _.uniq(
                this.dados.flatMap(item => {
                    if ( !item.item || !item.item.js_classes ) {
                        return [];
                    }

                    return item.item.js_classes;
                })
            ).sort();

            $('#' + this.modal_name).modal('show');
        }
    },

    beforeMount() {
        this.modal_name = 'modalInfoMedicamentos' + this.$util.uuidv4();
    }
}
</script>
